var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddUserGeequip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.1,
    y: 254.53,
    width: 18.62,
    height: 127.87,
    transform: "translate(456.82 636.93) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.66 382.4 219.1 382.4 219.1 358.1 232.53 358.1 225.66 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.02,
    y: 254.53,
    width: 18.62,
    height: 127.87,
    transform: "translate(850.67 636.93) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.1,
    y: 254.53,
    width: 202.64,
    height: 121.24,
    transform: "translate(640.85 630.29) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.19 382.4 421.75 382.4 421.75 358.1 408.32 358.1 415.19 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.83,
    y: 284.68,
    width: 100.29,
    height: 60.07,
    transform: "translate(70.26 699.68) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,268.09h11.88A20.15,20.15,0,0,0,404.56,263H365.38A20.17,20.17,0,0,0,379,268.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.28,
    y: 284.68,
    width: 100.29,
    height: 60.07,
    transform: "translate(5.71 635.13) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.87,268.09h11.89A20.17,20.17,0,0,0,339.41,263H300.23A20.14,20.14,0,0,0,313.87,268.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.73,
    y: 284.68,
    width: 100.29,
    height: 60.07,
    transform: "translate(-58.84 570.59) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33,268.09h11.88A20.17,20.17,0,0,0,274.86,263H235.68A20.15,20.15,0,0,0,249.33,268.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.61,
    y: 96.78,
    width: 127.06,
    height: 285.62,
    transform: "translate(276.27 479.18) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.61,
    y: 96.78,
    width: 124.38,
    height: 285.62,
    transform: "translate(273.59 479.18) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.47,
    y: 184.98,
    width: 272.66,
    height: 109.22,
    transform: "translate(376.38 102.79) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67,154h0a29.77,29.77,0,0,0-29.77-29.78H122.7A29.78,29.78,0,0,0,92.92,154h87.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.23,
    y: 282.52,
    width: 65.14,
    height: 87.75,
    transform: "translate(463.2 189.6) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.97,
    y: 172.33,
    width: 38.71,
    height: 113.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.92,
    y: 172.33,
    width: 38.71,
    height: 113.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,228.37H91.1a2.46,2.46,0,0,1-2.46-2.46h0a2.47,2.47,0,0,1,2.46-2.46H107a2.47,2.47,0,0,1,2.46,2.46h0A2.46,2.46,0,0,1,107,228.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53.16,
    y: 238.61,
    width: 272.66,
    height: 1.97,
    transform: "translate(322.76 156.42) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.03,
    y: 82.33,
    width: 134.74,
    height: 140.85,
    transform: "translate(698.81 305.51) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.64,
    y: 82.33,
    width: 134.74,
    height: 140.85,
    transform: "translate(692.02 305.51) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.77,
    y: 223.18,
    width: 146.01,
    height: 7.32,
    transform: "translate(687.55 453.68) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.95,
    y: 223.18,
    width: 138.49,
    height: 7.32,
    transform: "translate(672.38 453.68) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.16,
    y: 91.48,
    width: 127.7,
    height: 122.55,
    transform: "translate(498.77 -193.25) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.16,
    y: 149.36,
    width: 127.7,
    height: 6.79,
    transform: "translate(498.77 -193.25) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.17,
    y: 151.47,
    width: 127.7,
    height: 2.57,
    transform: "translate(438.77 -133.26) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.84,
    y: 151.47,
    width: 127.7,
    height: 2.57,
    transform: "translate(503.45 -197.93) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,226.53c-2.48-25.68-4.21-67.34-2.87-81.28a1.73,1.73,0,0,1,.7-1.2h0a1.71,1.71,0,0,1,2.72,1.43c-.23,6.91-.5,24.17,1,53.94.73,14.82,1.78,25,1.06,27.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.91,167.35c-7.06-7.84-21.47-13.41-36.15-13.38-5.77,0,17.54,9.11,27.23,19.16,7.53,7.8,16,20.93,18.91,28.22C299,186,298,175.18,290.91,167.35Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,169.74c5.86-8.16,19.38-14.44,34-15.15,5.74-.28-16.12,10-24.28,20.46-6.33,8.15-12.83,21.66-14.62,29.06C299.59,188.74,299,177.9,304.9,169.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.6,138.74c-6-6.64-18.18-11.36-30.62-11.33-4.88,0,14.85,7.72,23.06,16.22,6.38,6.61,13.57,17.73,16,23.9C297.47,154.55,296.57,145.37,290.6,138.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,148.55c5-6.91,16.41-12.23,28.81-12.83,4.86-.23-13.65,8.44-20.56,17.33-5.36,6.9-10.87,18.34-12.38,24.61C298,164.64,297.48,155.46,302.44,148.55Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,254.53h0a14.58,14.58,0,0,1-14.56-13.75l-1.29-22.32H317l-1.29,22.32A14.58,14.58,0,0,1,301.14,254.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.05 223.53 283.24 223.53 282.21 214.24 320.07 214.24 319.05 223.53",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-31"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-31",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3,113.53a6.3,6.3,0,0,1,6.28-6.28H338.8a6.3,6.3,0,0,1,6.28,6.28v20.21H52.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.07,125.79a5.3,5.3,0,1,1,5.3-5.3A5.3,5.3,0,0,1,103.07,125.79Zm0-9.49a4.19,4.19,0,1,0,4.19,4.19A4.2,4.2,0,0,0,103.07,116.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.24,125.79a5.3,5.3,0,1,1,5.31-5.3A5.3,5.3,0,0,1,86.24,125.79Zm0-9.49a4.19,4.19,0,1,0,4.2,4.19A4.2,4.2,0,0,0,86.24,116.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.42,125.79a5.3,5.3,0,1,1,5.31-5.3A5.3,5.3,0,0,1,69.42,125.79Zm0-9.49a4.19,4.19,0,1,0,4.19,4.19A4.2,4.2,0,0,0,69.42,116.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.8,326.57H58.58a6.3,6.3,0,0,1-6.28-6.28V133.74H345.08V320.29A6.3,6.3,0,0,1,338.8,326.57Z",
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.08,
    y: 139.11,
    width: 289.22,
    height: 165.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.25,
    y: 153.28,
    width: 117.79,
    height: 22.33,
    rx: 3.81,
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.32,154.28a2.81,2.81,0,0,1,2.81,2.81V171.8a2.81,2.81,0,0,1-2.81,2.81H215.15a2.81,2.81,0,0,1-2.81-2.81V157.09a2.81,2.81,0,0,1,2.81-2.81H325.32m0-1H215.15a3.82,3.82,0,0,0-3.81,3.81V171.8a3.81,3.81,0,0,0,3.81,3.81H325.32a3.81,3.81,0,0,0,3.81-3.81V157.09a3.82,3.82,0,0,0-3.81-3.81Z",
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.83,185.61a18.58,18.58,0,1,1-18.58,18.58,18.6,18.6,0,0,1,18.58-18.58m0-1a19.58,19.58,0,1,0,19.58,19.58,19.58,19.58,0,0,0-19.58-19.58Z",
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,211.89a16.16,16.16,0,0,1-28.41,0,25.56,25.56,0,0,1,28.41,0Z",
    style: {
      fill: "#2DA50C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.83,
    cy: 198.66,
    r: 7.2,
    style: {
      fill: "#2DA50C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,214.26H128.48a10.07,10.07,0,0,1-10.07-10.07h0a10.06,10.06,0,0,1,10.07-10.06H319.06a10.06,10.06,0,0,1,10.07,10.06h0A10.07,10.07,0,0,1,319.06,214.26Z",
    style: {
      fill: "#2DA50C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.83,239a18.58,18.58,0,1,1-18.58,18.58A18.59,18.59,0,0,1,87.83,239m0-1a19.58,19.58,0,1,0,19.58,19.58A19.58,19.58,0,0,0,87.83,238Z",
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,265.22a16.16,16.16,0,0,1-28.41,0,25.61,25.61,0,0,1,28.41,0Z",
    style: {
      fill: "#2DA50C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.83,
    cy: 252,
    r: 7.2,
    style: {
      fill: "#2DA50C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,247.46H319.06a10.07,10.07,0,0,1,10.07,10.07v0a10.07,10.07,0,0,1-10.07,10.07H128.48a10.07,10.07,0,0,1-10.07-10.07v0a10.06,10.06,0,0,1,10.06-10.06Z",
    style: {
      fill: "#2DA50C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.12,267.3a93.48,93.48,0,0,0,1.79,18.22,37.58,37.58,0,0,0-18.39,32.23,37.17,37.17,0,0,0,1,8.82H338.8a6.3,6.3,0,0,0,6.28-6.28v-144A93.33,93.33,0,0,0,272.12,267.3Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-31"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365.31,
    cy: 271.24,
    r: 83.19,
    transform: "translate(-84.8 337.75) rotate(-45)",
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.7,
    cy: 271.13,
    r: 75.84,
    transform: "translate(-84.61 338) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,220.25l-4.84,6.2s-4.25,3.22-5.86,6c-1.88,1.86-3.6,3.77-5.3,5.78a79.5,79.5,0,0,0-5.44,7.21,41.84,41.84,0,0,0-4.52,8.59,18.16,18.16,0,0,0-1.21,6,11.13,11.13,0,0,0,.76,4.25,10,10,0,0,0,3.17,4.2l1.06.8,1.59.3a53.59,53.59,0,0,0,9.52.94l1.26-.11L329,257.73c-1.07,0-3.37.21-4.42.19,0-.2.08-.4.13-.6a37.81,37.81,0,0,1,2.6-7c1.12-2.43,2.41-4.86,3.75-7.28,1.18-2.14,2.45-4.29,3.68-6.39l6-3.78,3.51-6.23Zm-15.61,39.5a1.68,1.68,0,0,1,0-.29.76.76,0,0,1,.09.23C324.62,259.93,324.55,259.94,324.5,259.75Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.19,233.65c.15-.77-5.11-3.41-8.73-1.26-3.13,1.86-3.53,4.4-2.39,7.43,0,.21.08.42.11.63.07.49.13,1,.16,1.46.23,3.19-.61,6.16-4.2,7.85,0,.2-.49.41-.65.55a7.15,7.15,0,0,0-2.38,4.55c0,1.3,1.23,2.33,2.66,3.57l2,1.35,2.74-.26c8.41-2.47,12.34-10.15,12.16-10.72C373.51,245.24,373.54,239,374.19,233.65Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.37,251.87l-1.52-.26c-2-.32-10.92-2.34-15.23-2.72h0c-1,2.13-4.28,7.33-12.69,9.8l-2.08.49-2-1a5.3,5.3,0,0,1-2.18-3.84,5.69,5.69,0,0,1,2.18-4,.66.66,0,0,0,.17-.23c0-.24,0-.4,0-.42-.63.08-8.61,1.29-9.28,1.4a130,130,0,0,0-22.07,6.13l.08.72,1.45,12.59.54,4.77s4-.45,9.25-1.37c-1.43,12.74-1.71,31.2,2.66,54.93l17.07-.32,29.66-.55c.12-2-.1-6.14-.31-11.8l-.27-8.74c-.16-7.72-.13-17,.56-26.92.11-1.57.24-3.15.38-4.75h0c6.06,6.55,12.13,12.81,12.13,12.81l2.87-2.76c3.67-1.77,6.56-4.94,9.08-8.75l3.37-3.25S400.57,253.25,392.37,251.87Z",
    style: {
      fill: "#2DA50C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.16,270.64a14.91,14.91,0,0,0,1.95,5.9l2.3,3.94c.11-1.57.24-3.15.38-4.75C387.21,274,385.63,272.29,384.16,270.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8,275.74h0c-.14,1.6-.27,3.18-.38,4.75h0C388.52,278.92,388.66,277.33,388.8,275.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.07,239.82c0,.21.07.42.11.63,0-.21-.07-.42-.11-.63Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.34,241.91c0-.48-.09-1-.16-1.46C363.25,240.94,363.31,241.43,363.34,241.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.56,237.45c-.2.14-.39.29-.6.43a11.54,11.54,0,0,1-5.89,1.94c0,.21.07.42.11.63.07.49.13,1,.16,1.46,0,0,0,.06,0,.09A10.08,10.08,0,0,0,369.56,237.45Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,250.41a2.23,2.23,0,0,0-1.66-1.7l-2.08-.5a1.24,1.24,0,0,0-1.36.59l-.07.09c-1,2.13-4.28,7.33-12.69,9.8l-.65.15h0l-1.43.34-2-1a5.3,5.3,0,0,1-2.18-3.84,5.69,5.69,0,0,1,2.18-4,2.16,2.16,0,0,0,.29-.37c.09-.23.07-.34-.09-.44-2.21-1.59-7.15.86-7.35,1.28-.21.21-.42.43-.63.68a6.93,6.93,0,0,0-1.6,5.3,10.69,10.69,0,0,0,5.07,7.76.23.23,0,0,0,.14,0,.29.29,0,0,0,.16,0,.33.33,0,0,0,.14-.27,6,6,0,0,1,3.7-5.52l1.75.94c-7.52,30.86-2.42,67.85-2.28,68.85h.58s0,0,0,0c0-.38-5.3-37.69,2.28-68.72l1.83-.44c2.13,2.6,1.12,6.46,1.11,6.5a.3.3,0,0,0,.09.3.31.31,0,0,0,.2.07.2.2,0,0,0,.11,0c.4-.18,9.86-4.32,13.17-8.27a15.8,15.8,0,0,0,3.22-6.5A2.12,2.12,0,0,0,380.79,250.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.56,237.45c-.2.14-.39.29-.6.43a11.54,11.54,0,0,1-5.89,1.94c0,.21.07.42.11.63.07.49.13,1,.16,1.46,0,0,0,.06,0,.09A10.08,10.08,0,0,0,369.56,237.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.21,215.37c3.91-5,1.43-8-.23-7.72-1.57.74-3.06,2.83-3.83,7.51a11.82,11.82,0,0,0-.08,3.34C354.68,218.42,357.21,215.37,357.21,215.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6,226.4c10.83-19.05-10.56-21.27-14.92-17a18.55,18.55,0,0,0-3.67,4.72l-.91,1.79a27.36,27.36,0,0,0-1,2.59,30.63,30.63,0,0,0-1.7,9.83,11.44,11.44,0,0,0,11.7,11.49h0a11.54,11.54,0,0,0,5.89-1.94c.21-.14.4-.29.6-.43a13.66,13.66,0,0,0,3.59-3.78C375.4,230.08,374.82,228.27,373.6,226.4Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,215.32a.42.42,0,0,0,.07.58.43.43,0,0,0,.26.09.37.37,0,0,0,.22-.08.25.25,0,0,0,.1-.08,3.46,3.46,0,0,1,2.73-1.37.42.42,0,0,0,.44-.39.41.41,0,0,0-.38-.44,4.22,4.22,0,0,0-2,.49A4.58,4.58,0,0,0,353.55,215.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.37,227.3a.21.21,0,0,0-.29,0,5.87,5.87,0,0,1-5,1.24.21.21,0,0,0-.24.16.22.22,0,0,0,.16.25,6.85,6.85,0,0,0,1.45.13,6,6,0,0,0,3.89-1.48A.21.21,0,0,0,364.37,227.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,220.16a26.31,26.31,0,0,1-4.69,5.21c1,1.38,3.16,1.28,3.16,1.28Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,220.4c.45.09,1-.39,1.11-1.08s-.07-1.31-.52-1.4-.95.39-1.11,1.08S355,220.31,355.46,220.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,222c.45.09.94-.39,1.11-1.08s-.08-1.31-.53-1.4-.95.39-1.11,1.08S362.82,221.87,363.28,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.45,211.1c4.23-3.62-5.41-11-5.41-11s1.08,2.64-1.16,3.37-18-5.15-17.77,1.52a5.12,5.12,0,0,0,.87,2.63,7.6,7.6,0,0,0,1.7,1.75C362.34,212.15,369,213,372.6,213a18.54,18.54,0,0,0-1.19,4.34,11.55,11.55,0,0,0,2.19,9c2,3.48,4.67,3.38,6.95.73C384.21,223.61,387.74,216.6,380.45,211.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,225.07c-1.66-.68-3.53.12-5,1.33a9.67,9.67,0,0,0-2.07,2.27c-1.41,2.21-.91,4.78,1.62,5l.44,0,.6,0a8.71,8.71,0,0,0,5.27-2.5,4.05,4.05,0,0,0,1.09-4A3.25,3.25,0,0,0,378.61,225.07Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,328.81s-.27,2.34-.69,6.27a75.91,75.91,0,0,0,47.29.44c.1-4.75.17-7.59.17-7.59l-29.7.56h-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,288.54a9.9,9.9,0,0,0-.58-2.49,9.26,9.26,0,0,0-.51-1.16l-.29-.54-.16-.28c-1.43-2.46-3-4.79-4.6-7l-9.08,8.75c1.2,1.5,2.37,3,3.45,4.54a7.17,7.17,0,0,1-.77,1.45,33,33,0,0,1-5,5.51,147.39,147.39,0,0,1-12.29,9.93l-1.39.18-5.58.76-5.49,3.71,3.61,7.34,4.54-2.32a17.43,17.43,0,0,0,3.19-.75,6.82,6.82,0,0,0,3.93-2.78,83.26,83.26,0,0,0,7.79-3.56,77.34,77.34,0,0,0,7.9-4.69q1.93-1.32,3.82-2.89a29.3,29.3,0,0,0,3.7-3.63,16.68,16.68,0,0,0,3.26-5.57A10.72,10.72,0,0,0,419,288.54Zm-11.69,1.58c0-.05,0-.11,0-.15,0-.24.09-.33.09-.19A1.07,1.07,0,0,1,407.33,290.12Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.97,
    cy: 313.69,
    r: 27.45,
    transform: "translate(-63.59 552.63) rotate(-80.78)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.06,311.12H295.54V298.6a2.57,2.57,0,1,0-5.14,0v12.52H277.88a2.57,2.57,0,0,0,0,5.14H290.4v12.52a2.57,2.57,0,1,0,5.14,0V316.26h12.52a2.57,2.57,0,0,0,0-5.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.77,216.76a3.16,3.16,0,0,1,2.28,1.86.42.42,0,0,0,.38.24.35.35,0,0,0,.17,0,.41.41,0,0,0,.2-.55,4,4,0,0,0-2.92-2.33.41.41,0,0,0-.11.82Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserGeequip);
export default __webpack_public_path__ + "static/media/add-user-geequip.1bd94fdc95a4534e1cb16df903520292.svg";
export { ForwardRef as ReactComponent };